module.exports = __webpack_public_path__ + "img/colorPickerCancel.a1fab503.svg";